module.exports = __webpack_public_path__ + "static/media/SEANPNG.614c75f4.png";